const urls = {
  dashboard: '/',
  login: '/login/index.html',
  audit: '/audit/index.html',
  options: '/options/index.html',
  terms: '/terms/index.html',
  manage: '/manage/index.html',
  accountLogout: {
    host: 'https://account.collegeboard.org/login/logout',
    param: '?DURL=',
  },
  accountLogin: {
    host: 'https://account.collegeboard.org/login/login',
    param: '?DURL=',
  },
  accountAccessUrl: {
    host: 'https://cbaccount.collegeboard.org/professional/enroll',
    param1: '?appId=',
    param2: '&DURL=',
  }
};

const APP_ID = 390;

export default {
  urls,
  APP_ID,
};
